import { useCallback, useEffect, useState } from "react";
import { MessagesSquare } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { TicketList } from "@/components/hub/TicketList";
import { TicketThread } from "@/components/hub/TicketThread";
import { Chip } from "@/pages/Suggestions";

export const SupportTab = () => {
  const { t } = useI18n();
  const [status, setStatus] = useState("");
  const [list, setList] = useState([]);
  const [active, setActive] = useState(null);
  const load = useCallback(() => api.get("/admin/tickets", { params: { status: status || undefined } }).then((r) => setList(r.data)), [status]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="grid xl:grid-cols-[400px_1fr] gap-6 items-start">
      <div className="space-y-4">
        <div className="flex flex-wrap gap-2">
          <Chip testid="admin-tk-filter-all" active={!status} onClick={() => setStatus("")}>{t("adm.all")}</Chip>
          {["open", "answered", "closed"].map((x) => <Chip key={x} testid={`admin-tk-filter-${x}`} active={status === x} onClick={() => setStatus(x)}>{t(`sup.st_${x}`)}</Chip>)}
        </div>
        <TicketList list={list} active={active} admin onPick={(id) => { setActive(id); setTimeout(load, 400); }} />
      </div>
      {active ? <TicketThread key={active} id={active} admin onChange={load} /> : (
        <div className="cx-card rounded-2xl min-h-[420px] grid place-items-center p-8"><MessagesSquare className="w-10 h-10 text-[#2f7bff]" /></div>
      )}
    </div>
  );
};
